import { Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { CulturalLeadershipFrameworkAuthService } from "@org-common/lib/cultural-leadership/cultural-leadership-framework-auth.service";
import { CulturalDataFilterParamKeys } from "../../cultural-data-filter";
import { CareerValuationAuthService } from "../career-valuation-auth.service";
import { CareerValuationFilterService } from "../career-valuation-filter/career-valuation-filter.service";

@Component({
    selector: "adapt-analyse-cvt-page",
    templateUrl: "./analyse-cvt-page.component.html",
    standalone: false,
})
export class AnalyseCareerValuationPageComponent extends BaseRoutedComponent implements OnInit {
    public readonly CareerValuationFilterParamKeys = Object.values(CulturalDataFilterParamKeys);

    public canCompare = false;
    public showComparison = false;

    public constructor(
        private careerValuationAuthService: CareerValuationAuthService,
        private culturalLeadershipFrameworkAuthService: CulturalLeadershipFrameworkAuthService,
        public filterService: CareerValuationFilterService,
        injector: Injector,
    ) {
        super(injector);

        this.filterService.reset();
    }

    public async ngOnInit() {
        this.canCompare = this.careerValuationAuthService.currentPersonHasAtLeastQuantitativeAccess()
            || await this.culturalLeadershipFrameworkAuthService.currentPersonIsCulturalLeader();
        this.notifyActivated();
    }
}
